import { combineLatest, map, Observable } from 'rxjs';
import { AppendState as AppendUserState, UserSession } from 'src/core/state/user';

import { AppendState as AppendCartState, CartVariant } from '../cart.reducer';

export function cartId(state$: Observable<AppendCartState>): Observable<AppendCartState['cart']['cartId']> {
    return state$.pipe(map((s) => s?.cart?.cartId));
}

/**
 * @param state$
 */
export function cartVariantAndId(
    state$: Observable<AppendCartState<AppendUserState>>,
): Observable<[CartVariant, AppendCartState['cart']['cartId']]> {
    const cartVariant$: Observable<CartVariant> = state$.pipe(
        map((s) => s?.user?.session),
        map((s) => (s === UserSession.SignedIn ? CartVariant.Account : CartVariant.Guest)),
    );
    return combineLatest([cartVariant$, cartId(state$)]);
}

export function cartItems(state: Observable<AppendCartState>) {
    return state.pipe(map((s) => s?.cart?.items));
}
